var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dateRange"},_vm._l((_vm.dateRange),function(item){return _c('span',{key:item.date,class:_vm.currentDateRange == item.date ? 'active' : 'unactive',on:{"click":function($event){return _vm.changeRange(item.date)}}},[_vm._v(_vm._s(item.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }